import { createContext, useContext } from 'react'

interface DocumentLayoutContextValues {
  isSidebarRightOpen: boolean
  toggleSidebarRight: () => void
}

export const DocumentLayoutContext = createContext<DocumentLayoutContextValues>(
  {
    isSidebarRightOpen: false,
    toggleSidebarRight: () => {},
  }
)

export const useDocumentLayoutContext = () => {
  const context = useContext(DocumentLayoutContext)!

  return context
}
